/**
 * Opens the read-only group details page (name + members with date added) in a new tab.
 * Used from ExtendedAvatar and any code that should match the approval/members UX (#66049).
 */
export function getGroupReadOnlyDetailsPath(groupId: string): string {
    const id = (groupId || '').trim();
    return id ? `/groups/${id}/details` : '';
}

export function getGroupReadOnlyDetailsAbsoluteUrl(groupId: string): string {
    const path = getGroupReadOnlyDetailsPath(groupId);
    if (!path) {
        return '';
    }
    return `${window.location.origin}${path}`;
}

export function openGroupDetailsInNewTab(groupId: string): void {
    const url = getGroupReadOnlyDetailsAbsoluteUrl(groupId);
    if (!url) {
        return;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
}
